/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import analyticsLib from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression, ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import classNames from 'classnames';
import { SkittlePopoverText } from '../skittle-popover-text/skittle-popover-text';
import styles from '../comparison-grid.module.less';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE } from '../../lib/analytics-constants';
import { getSkittleIcon } from '../../lib/product-constants';
export var ComparisonGridSkittle = function ComparisonGridSkittle(_ref) {
  var analytics = _ref.analytics,
      numEntitiesToCompare = _ref.numEntitiesToCompare,
      onCompareSkittleClick = _ref.onCompareSkittleClick,
      showSkittlePopover = _ref.showSkittlePopover,
      updateShowSkittlePopover = _ref.updateShowSkittlePopover,
      skittleTitle = _ref.skittleTitle,
      skittleContent = _ref.skittleContent,
      productType = _ref.productType,
      classes = _ref.classes;

  var internalSkittleClick = function internalSkittleClick(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.OPEN,
      entity_name: ENTITY_NAME.COMPARISON_GRID_SKITTLE,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
    onCompareSkittleClick();
  };

  return /*#__PURE__*/React.createElement(ElementImpression, {
    id: ENTITY_NAME.COMPARISON_GRID_SKITTLE,
    elementName: ENTITY_NAME.COMPARISON_GRID_SKITTLE,
    sectionCategory: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
  }, /*#__PURE__*/React.createElement(Impression, {
    className: styles.skittle,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    entityName: ENTITY_NAME.COMPARISON_GRID_SKITTLE,
    payload: {
      section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName
    }
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(Fragment, null, showSkittlePopover && /*#__PURE__*/React.createElement(SkittlePopoverText, {
      updateShowSkittlePopover: updateShowSkittlePopover,
      skittleTitle: skittleTitle,
      skittleContent: skittleContent
    }), /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "open",
      elementName: ENTITY_NAME.COMPARISON_GRID_SKITTLE,
      id: "".concat(ENTITY_NAME.COMPARISON_GRID_SKITTLE, "_open"),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.skittleIconAndCounter, classes === null || classes === void 0 ? void 0 : classes.iconAndCounter),
      onClick: function onClick() {
        return internalSkittleClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, getSkittleIcon(productType, classes === null || classes === void 0 ? void 0 : classes.icon), numEntitiesToCompare > 0 && /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.skittleCounter, classes === null || classes === void 0 ? void 0 : classes.counter)
    }, numEntitiesToCompare))));
  })));
};
ComparisonGridSkittle.defaultProps = {
  showSkittlePopover: false,
  updateShowSkittlePopover: function updateShowSkittlePopover() {},
  numEntitiesToCompare: 0,
  onCompareSkittleClick: function onCompareSkittleClick() {}
};
ComparisonGridSkittle.propTypes = {
  analytics: PropTypes.shape({
    sectionName: PropTypes.string
  }),
  numEntitiesToCompare: PropTypes.number,
  onCompareSkittleClick: PropTypes.func,
  updateShowSkittlePopover: PropTypes.func,
  showSkittlePopover: PropTypes.bool,
  skittleTitle: PropTypes.string,
  skittleContent: PropTypes.string,
  classes: PropTypes.shape({
    iconAndCounter: PropTypes.string,
    icon: PropTypes.string,
    counter: PropTypes.string
  })
};